export const createSortColumns = (setSort, onSortColumn) => [
    {
      label: 'Date Opened',
      sortColumn: 'opened_date',
      sortBy: setSort?.sidx,
      sortDirection: setSort?.sord,
      setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
      type: 'date',
    },
    {
      label: 'Last Updated',
      sortColumn: 'updated_at',
      sortBy: setSort?.sidx,
      sortDirection: setSort?.sord,
      setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
      type: 'date',
    },
  ];
